<template>
    <PageLayoutForms>
        <template #header>
            <h1 class="pdp-mandate-onboarding__title typographies-heading-h1">
                {{ $t.__('pdp.mandate.Onboarding.title') }}
            </h1>
        </template>
        <template #sidebar-left>
            <OnboardingSidebar />
        </template>
        <template #content>
            <InformationBanner
                :title="$t.__('pdp.mandate.Onboarding.InformationBanner.title')"
                sourceIllustration="/ressources/logged/img/illustrations/pdp/invoicing-blocked.svg"
            >
                <template #description>
                    <div
                        class="pdp-mandate-onboarding__information typographies-paragraph-medium-regular"
                        v-html="informationBannerDescription"
                    />
                </template>
            </InformationBanner>
            <template v-if="isAdmin">
                <h2 class="pdp-mandate-onboarding__subtitle typographies-heading-h2">
                    {{ $t.__('pdp.mandate.Onboarding.subtitle') }}
                </h2>
                <div class="pdp-mandate-onboarding__choices">
                    <OnboardingChoice
                        v-for="choice in ['issue', 'receipt']"
                        :key="choice"
                        :type="choice"
                        :disabled="isDisabled && choice === 'issue'"
                        :state="choiceState(choice)"
                        @select="(selected) => (selectedMandateType = selected)"
                    />
                </div>
            </template>
            <CompassEmptyState
                v-else
                :title="$t.__('pdp.mandate.Onboarding.EmptyState.title')"
                :caption="$t.__('pdp.mandate.Onboarding.EmptyState.caption')"
                illustrationPath="/ressources/logged/img/illustrations/contact-unlocked.svg"
            />
        </template>
        <template #footer>
            <FooterFullPage :primaryAction="primaryAction" :secondaryActions="secondaryActions" />
        </template>
    </PageLayoutForms>
</template>
<script>
import InformationBanner from 'vcomponents/common/InformationBanner/InformationBanner.vue';
import OnboardingSidebar from 'vcomponents/pa/mandate/Onboarding/OnboardingSidebar.vue';
import FooterFullPage from 'vcomponents/common/FooterFullPage/FooterFullPage.vue';
import OnboardingChoice from 'vcomponents/pa/mandate/Onboarding/OnboardingChoice.vue';
import { createNamespacedHelpers } from 'vuex';
import PageLayoutForms from 'vcomponents/common/layout/pages/PageLayoutForms.vue';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
import { getEInvoicingMandate } from 'api/corp/corp';

export default {
    components: {
        InformationBanner,
        OnboardingSidebar,
        FooterFullPage,
        OnboardingChoice,
        PageLayoutForms,
    },
    data() {
        return {
            selectedMandateType: null,
            informationBannerDescription: this.$t.__(
                'pdp.mandate.Onboarding.InformationBanner.description',
                {
                    paragraphStart: '<p>',
                    paragraphEnd: '</p>',
                    boldStart: '<strong>',
                    boldEnd: '</strong>',
                },
            ),
            isLoading: false,
            mandates: [],
            isDisabled: false,
        };
    },
    computed: {
        ...mapStateUser(['isAdmin']),
        primaryAction() {
            return {
                label: this.$t.__('pdp.mandate.Onboarding.primaryAction.label'),
                disabled: !this.isAdmin || !this.selectedMandateType,
                action: () => {
                    this.$emit('mandateTypeSelected', this.selectedMandateType);
                },
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    action: () => {
                        this.$router.push({ name: 'dashboard' });
                    },
                },
            ];
        },
    },
    created() {
        this.getMandates();
    },
    methods: {
        choiceState(type) {
            if (!this.selectedMandateType) {
                return 'default';
            }
            return this.selectedMandateType === type ? 'selected' : 'unselected';
        },
        getMandates() {
            this.isLoading = true;
            getEInvoicingMandate()
                .then((response) => {
                    this.mandates = response.data;
                })
                .catch((error) => {
                    if (error.response.status !== 404) {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$t.__('settings.mandate.fetch_error'),
                        });
                    } else {
                        this.mandates = [];
                    }
                })
                .finally(() => {
                    if (
                        this.mandates.length &&
                        this.mandates.some((mandate) => mandate.types.includes('issue'))
                    ) {
                        this.selectedMandateType = 'receipt';
                        this.isDisabled = true;
                    }
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.pdp-mandate-onboarding {
    &__subtitle {
        margin: var(--spacing-5) 0 var(--spacing-3);
    }

    &__information {
        color: var(--colors-common-text-brand-secondary-blue);

        &::v-deep {
            p {
                margin: 0;

                & + p {
                    margin-top: var(--spacing-3);
                }
            }
        }
    }

    &__choices {
        display: flex;
        gap: var(--spacing-4);
    }

    &::v-deep {
        .compass-empty-state {
            margin: var(--spacing-5) 0 0;
        }
    }
}
</style>
